import * as React from 'react'
import * as styles from './Fallback.module.scss'
import * as cn from 'classnames'

interface FallbackProps {
  customerMessage?: string
}

// This message should only be displayed if WPS is down
const UnlocalizedGenericMessage = () => (
  <div>
    <p>This page is temporarily unavailable.</p>
    <p>We apologize for the inconvenience and ask that you try again later.</p>
  </div>
)

const Fallback = ({ customerMessage }: FallbackProps) => (
  <div className={cn('tst-fallback', styles.Fallback)}>
    {customerMessage ? (<p>{customerMessage}</p>) : (<UnlocalizedGenericMessage />)}
  </div>
)

export default Fallback
